import * as React from "react";
import Dialog from "@mui/material/Dialog";
import DialogContent from "@mui/material/DialogContent";
import { Box, Button, Typography } from "@mui/material";
import { useDispatch, useSelector } from "react-redux";
import { toggleSessionModal } from "../redux/sessionSlice";
import { clearAuthData } from "../redux/authSlice";
import { clearProfileData } from "../redux/profileSlice";
import { clearAccountContract } from "../features/capabilities/capabilitySlice";

const SessionModal = () => {
  const isOpen = useSelector((state) => state?.session?.isOpen);
  const dispatch = useDispatch();
  const handleClose = () => {
    dispatch(toggleSessionModal(isOpen));
    dispatch(clearAuthData());
    dispatch(clearProfileData());
    dispatch(clearAccountContract());
    localStorage.removeItem("persist:root");
    localStorage.removeItem("role");
    localStorage.removeItem("token");
    window.location.replace("/");
  };

  return (
    <Dialog
      onClose={() => handleClose()}
      aria-labelledby="customized-dialog-title"
      open={isOpen}
      sx={{
        "& .MuiDialog-paper": {
          backgroundColor: "#fff", // Background color of the dialog
          padding: {
            xs: 0,
            sm: "30px 40px",
            md: "30px 40px",
            lg: "30px 50px",
            xl: "40px 70px",
          },
          borderRadius: "20px", // Rounded corners
          maxWidth: {
            xs: "320px",
            sm: "550px",
            md: "550px",
            lg: "600px",
            xl: "640px",
          }, // Max width
        },
        "& .MuiBackdrop-root": {
          backgroundColor: "rgba(0, 0, 0, 0.7)", // Darker overlay
        },
      }}
    >
      <DialogContent>
        <Box>
          <Typography
            sx={{
              color: "#2A4876",
              textAlign: "center",
              fontSize: {
                xs: "20px",
                sm: "24px",
                md: "24px",
                lg: "26px",
                xl: "32px",
              },
              fontWeight: 600,
            }}
          >
            Session Expired
          </Typography>

          <Typography
            sx={{
              fontSize: {
                xs: "14px",
                sm: "15px",
                md: "15px",
                lg: "15px",
                xl: "16px",
              },
              fontWeight: 400,
              lineHeight: {
                xs: "21px",
                sm: "24px",
              },
              color: "#152134",
            }}
          >
            You will be redirected to homepage
          </Typography>
          <Button
            onClick={handleClose}
            sx={{
              backgroundColor: "#2A4876",
              width: "100%",
              marginTop: "20px",
              borderRadius: "50px",
              height: {
                xs: "40px",
                sm: "40px",
                md: "40px",
                lg: "50px",
                xl: "70px",
              },
              fontSize: {
                xs: "14px",
                sm: "15px",
                md: "16px",
                lg: "16px",
                xl: "18px",
              },
              fontWeight: 600,
              color: "#fff",
            }}
          >
            Ok
          </Button>
        </Box>
      </DialogContent>
    </Dialog>
  );
};

export default SessionModal;
